import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cx-tooltip__title"
}

import { ref,
  onUpdated,
  computed,
  onMounted } from 'vue';
import { TooltipPosition } from './TooltipPosition.enum';
import { TooltipProps } from '@/components/tooltip/TooltipProps';


export default /*#__PURE__*/_defineComponent({
  __name: 'CxTooltip',
  props: {
    show: { type: Boolean, default: false },
    text: {},
    position: { default: TooltipPosition.TopCenter },
    top: { default: 0 },
    left: { default: 0 },
    offsetTop: { default: -3 },
    offsetLeft: { default: 0 },
    animationDelay: { default: 0.5 },
    parentElement: {},
    maxWidth: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const cxTooltipElement = ref<HTMLElement | null>(null);

const tooltipWidth = ref(0);
const tooltipHeight = ref(0);
const parentWidth = ref(0);
const parentHeight = ref(0);

const calculateTooltipPosition = () => {
  const parent = props.parentElement || cxTooltipElement.value?.parentElement;
  if (!cxTooltipElement.value || !props.show) return;
  tooltipWidth.value = cxTooltipElement.value?.getBoundingClientRect().width || 0;
  tooltipHeight.value = cxTooltipElement.value?.getBoundingClientRect().height || 0;
  if (parent) {
    parentWidth.value = parent.getBoundingClientRect().width;
    parentHeight.value = parent.getBoundingClientRect().height;
  }
};
onMounted(calculateTooltipPosition);
onUpdated(calculateTooltipPosition);

const computedTop = computed(() => {
  if (!props.show) return '';
  switch (props.position) {
    case TooltipPosition.TopCenter:
    case TooltipPosition.TopLeft:
    case TooltipPosition.TopRight: {
      return props.top ? `${props.top - tooltipHeight.value + props.offsetTop}px` : 'none';
    }
    case TooltipPosition.BottomCenter:
    case TooltipPosition.BottomLeft:
    case TooltipPosition.BottomRight: {
      return props.top ? `${props.top + parentHeight.value - props.offsetTop}px` : 'none';
    }
    default:
      return '';
  }
});

const computedLeft = computed(() => {
  if (!props.show) return '';
  const parentHalf = parentWidth.value / 2.0;
  const selfHalf = tooltipWidth.value / 2.0;
  switch (props.position) {
    case TooltipPosition.TopCenter:
    case TooltipPosition.BottomCenter: {
      return `${props.left + parentHalf - selfHalf + props.offsetLeft}px`;
    }
    case TooltipPosition.TopLeft:
    case TooltipPosition.BottomLeft: {
      return `${props.left - props.offsetLeft}px`;
    }
    case TooltipPosition.TopRight:
    case TooltipPosition.BottomRight: {
      return `${props.left + parentHalf + props.offsetLeft}px`;
    }
    default:
      return '';
  }
});

const computedMaxWidth = computed(() => {
  if (props.maxWidth) return `${props.maxWidth}px`;
  return 'auto';
});

const computedClass = computed(() => {
  return {
    'cx-tooltip--wrap': !!props.maxWidth
  };
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "cxTooltipElement",
          ref: cxTooltipElement,
          class: _normalizeClass(["cx-tooltip", computedClass.value]),
          style: _normalizeStyle({
        top: computedTop.value,
        left: computedLeft.value,
        'animation-delay': `${_ctx.animationDelay}s`,
        maxWidth: computedMaxWidth.value
      })
        }, [
          (_ctx.text)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.text), 1))
            : _createCommentVNode("", true)
        ], 6))
      : _createCommentVNode("", true)
  ]))
}
}

})